import { ServiceBase, Result } from "./ServiceBase";
import { User } from "../models/User";
import { AzureToken } from "../models/AzureToken";
import { AzureConfigurations } from "../auth-config";

export class AzureTokenRequest {
    impactPartnerId: string;
    code: string;
};

export class AzureRefreshTokenRequest {
    impactPartnerId: string;
    refreshToken: string;
}

export class AzureTokenResponse {
    token: AzureToken;
    user: User;
    logoutUrl: string;
    isLogout: boolean;
}

export class GetAzureClientTokenRequest {
    impactPartnerId: string;
}

export default class AuthenticationService extends ServiceBase {

    public static async loadAllTemp(): Promise<Result<User[]>> {

        var result = await this.requestNotAuthJson<User[]>({
            url: `/api/Authorization/loadAllTemp`,
            method: "GET"
        });

        return result;
    }

    public static async getAzureToken(model: AzureTokenRequest): Promise<Result<AzureTokenResponse>> {

        var result = await this.requestNotAuthJson<AzureTokenResponse>({
            url: `/api/Authorization/getAzureToken/`,
            method: "POST",
            data: model
        });

        return result;
    }

    public static async getAzureConfigurations(): Promise<Result<AzureConfigurations>> {

        var result = await this.requestNotAuthJson<AzureConfigurations>({
            url: `/api/Authorization/getAzureConfigurations`,
            method: "GET"
        });

        return result;
    }
}
